import React, {Component} from 'react';
import {Redirect, Link} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  Label,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import $ from 'jquery';
import QuestionPage from '../views/QuestionPage/';
import ViewQuestionSetup from './ViewQuestionSetup';
const GLOBAL = require('../Globals');

class SetupQuestions extends Component {
	 
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			idd : '',
			acyear : '',
			cls : '',
			section : '',
			value : [],
			lessons : [],
			type : '',
			suborder : '',
			subje : '',
			stype : '',
			sorder : '',
			isdisplay : 0,
			_message : '',
			alertClass :'',
			posts : [],
			secs : [],
			accyear : [],
			subj : [],
			_redirect : false,
			subject :[],
			modal: false,
			assub : [],
			data : [],
			editData : [],
			isbtnview : false,
			viewmodal : false,
			isview : false,
		}
		this.onacChange = this.onacChange.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	onViewClick(id,name,e){
		this.setState({questionid : id,questionname:name,viewmodal : true});
	}
	
	onacChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		
		if (window.confirm("Do you want to Delete?")) { 
			$("#showLoader").show();
			GetData('question/deletequestionsetup/'+this.state.id).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Question Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getSetupQuestion();
				}
				else{
			
					this.setState({
						_message:responseJson.msg,
						alertClass:'alert alert-danger'
					});
				}
			});
		}		
	}

	onUpdate(id){
		var dat = this.state.data.filter(function(obj){
			return (obj.questionid == id);
		})
		this.setState({editData : dat,questionid : id,_redirect : true});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getsubject();
				this.getSetupQuestion();
				this.getlesson();
			}
		});
	}

	getsubject(){
		
		var ac = $("#year").val();
        if(this.state.userRole == 'questionbank'){
			$("#showLoader").show();
			GetData('assignsubject/getsubbystaffid/'+ac+'/'+this.state.staffid).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson){
					this.setState({
						subject : responseJson
					});
				}
			});
		}
	}

	getlesson(){
		GetData('question/getlessons').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					lessons: responseJson
				});
			}
		});
	}

	getSetupQuestion(){
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('question/getquestionsetup/'+ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				var dat = [];
				if(this.state.userRole == 'questionbank'){
					for(var i=0;i<responseJson.length;i++){
						if(this.checkSubject(responseJson[i].subject)){
							dat.push(responseJson[i]);
						}
					}
				}
				else{
					dat = responseJson;
				}
				this.setState({
					data : dat
				});
			}
		});
	}

	getLessonName(lesson){
		var d = this.state.lessons;
		var name= '';
		var ar = lesson.split(",");

		for(var i=0;i<ar.length;i++){
			d.filter(function(obj){
				if(obj.id == ar[i]){
					name+=obj.lesson+', ';
				}
			})
		}
		return name.replace(/,\s*$/, "");
	}

	checkSubject(subid){
		var d = this.state.subject;
		var index = d.findIndex(function(obj){
			return(obj.subject == subid);
		});
		if(index != -1){
			return true;
		}else{
			return false;
		}
	}
	
  render() {
	
	var acyear = this.state.accyear;

	let userData = JSON.parse(sessionStorage.getItem('userData'));
    this.state.userId = userData['userid'];
	this.state.userRole = userData['userrole'];
	this.state.staffid = userData['staffid'];

	if(this.state._redirect){
		  
		return (<Redirect to={'/questions/editsetup/'+this.state.questionid} />);
    }

    return (
		<div>
		  <QuestionPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card>
					  
						<CardHeader>
							<strong>Question Setup</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onacChange} required id="year">
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							</select>
							<Link to="/questions/addsetup" className="btn btn-success" style={{float : 'right'}} >Add</Link>
						</CardHeader>
						<CardBody id="asubbody">
							<Row style={{marginTop : '20px'}}>
								<Col md="12">
									<Table responsive bordered >
										<thead>
											<tr>
												<th>S.No</th>
												<th>Class</th>
												<th>Subject</th>
												<th>Lesson</th>
												<th>No.Of Questions</th>
												<th>Question Id</th>
												<th>Selection Process</th>
												<th>Status</th>
												<th>Manage</th>
											</tr>
										</thead>
										<tbody>
											{this.state.data.map((item,i)=>
												<tr>
													<td>{i+1}</td>
													<td>{item.clsname}</td>
													<td>{item.subname}</td>
													<td>{this.getLessonName(item.lesson)}</td>
													<td>{item.qcount}/{item.noofquestions}</td>
													<td>{item.questionname}</td>
													<td style={{textTransform : 'capitalize'}}>{item.selection}</td>
													<td>{item.qusstatus}</td>
													<td>
														<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.questionid)} data-toggle="tooltip" data-placement="top" title="Edit"><i className="fa fa-edit"></i></button>
														&nbsp;&nbsp;
														<button name="editacyear" className="btn btn-warning btn-sm" onClick={this.onViewClick.bind(this,item.questionid,item.questionname)} data-toggle="tooltip" data-placement="top" title="View"><i className="fa fa-eye"></i></button>
														&nbsp;&nbsp;
														<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.questionid)} data-toggle="tooltip" data-placement="top" title="Delete"><i className="fa fa-remove"></i></button>
													</td>
												</tr>
												)}
										</tbody>
									</Table>
								</Col>
						  	</Row>
							<Modal isOpen={this.state.viewmodal} size="lg" toggle={()=>{this.setState({viewmodal : false})}} className={this.props.className}>
								<ModalHeader toggle={()=>{this.setState({viewmodal : false})}}>View Question Setup - {this.state.questionname}</ModalHeader>
								<ModalBody>
									<ViewQuestionSetup id={this.state.questionid} lessons={this.state.lessons} />
								</ModalBody>
							</Modal>
						</CardBody>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default SetupQuestions;


// WEBPACK FOOTER //
// ./src/Questions/SetupQuestions.js